import { toastr } from 'react-redux-toastr'
import * as ActionTypes from '../../actions/actionTypes'
import * as actions from '../../actions/expediaActions'
import { getParser } from '../../adapters'
import { urlParams } from '../../utils/mainUtils'
import { handleError, handleResponse, securedFetch, showImportCategoriesToastr } from '../apiUtils'
import * as urls from '../urls'

/** @thunk **/
export const fetchExpediaCategories = params => (dispatch, getState) => {
    dispatch({ type: ActionTypes.EXPEDIA_CATEGORIES_FETCH_REQUEST })
    const { auth } = getState()

    securedFetch(urlParams(urls.expediaCategoriesFind, params), auth, { method: 'GET' })
        .then(handleResponse)
        .then(json => dispatch(actions.expedia_fetchCategoriesSuccess(getParser(urls.expediaCategories)(json))))
        .catch(
            handleError(
                dispatch,
                actions.expedia_fetchCategoriesFailure,
                'Что-то пошло не так!',
                'При получении категорий произошла ошибка'
            )
        )
}

/** @thunk **/
export const postExpediaCategory = category => (dispatch, getState) => {
    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(category)
    }
    const { auth } = getState()

    securedFetch(urls.expediaCategories, auth, opts)
        .then(handleResponse)
        .then(json => dispatch(actions.expedia_saveCategoriesSuccess(json)))
        .then(() => toastr.success('Категория успешно сохранена'))
        .catch(
            handleError(
                dispatch,
                actions.expedia_saveCategoriesFailure,
                'Что-то пошло не так!',
                'При сохранении категорий произошла ошибка'
            )
        )
}

/** @thunk **/
export const deleteExpediaCategory = remoteId => (dispatch, getState) => {
    const { auth } = getState()

    securedFetch(urls.expediaCategorySelf(remoteId), auth, { method: 'DELETE' })
        .then(handleResponse)
        .then(() => dispatch(actions.expedia_deleteCategorySuccess(remoteId)))
        .then(() => toastr.success('Категория удалена'))
        .catch(
            handleError(
                dispatch,
                actions.expedia_deleteCategoryFailure,
                'Что-то пошло не так!',
                'При удалении категории произошла ошибка'
            )
        )
}

/** @thunk **/
export const importExpediaCategories = () => (dispatch, getState) => {
    const { auth, expediaCurrentOrganization } = getState()

    const opts = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ organizationId: expediaCurrentOrganization })
    }

    securedFetch(urls.reloadCategoriesFromExpedia, auth, opts)
        .then(handleResponse)
        .then(showImportCategoriesToastr)
        .then(json =>
            dispatch(actions.expedia_importCategoriesSuccess(getParser(urls.reloadCategoriesFromExpedia)(json)))
        )
        .catch(
            handleError(
                dispatch,
                actions.expedia_importCategoriesFailure,
                'Что-то пошло не так!',
                'При импорте категорий произошла ошибка'
            )
        )
}



// WEBPACK FOOTER //
// ./src/api/expediaApi/expediaCategories.js